import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconListBullet20(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={20}
            height={20}
            className={customClassName}
            name="IconListBullet20"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M4 4.75a1 1 0 1 1-2 0 1 1 0 0 1 2 0m13.288.75a.75.75 0 0 0 0-1.5H6.213a.75.75 0 0 0 0 1.5zM14.732 9a.75.75 0 0 0 0-1.5h-8.52a.75.75 0 0 0 0 1.5zm3.306 2.75a.75.75 0 0 1-.75.75H6.213a.75.75 0 0 1 0-1.5h11.075a.75.75 0 0 1 .75.75M14.732 16a.75.75 0 0 0 0-1.5h-8.52a.75.75 0 0 0 0 1.5zM3 9.25a1 1 0 1 0 0-2 1 1 0 0 0 0 2m1 2.5a1 1 0 1 1-2 0 1 1 0 0 1 2 0m-1 4.5a1 1 0 1 0 0-2 1 1 0 0 0 0 2"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconListBullet20);
